<template>
  <div id="app" class="box">
    <Header />
    <Editor @selectedPeriodChange="selectedPeriodChange" />
    <Footer />
  </div>
</template>

<script>
  import Vue from 'vue';
  import Header from './components/Header/Header.vue';
  import Editor from './components/Editor/Editor.vue';
  import Footer from './components/Footer/Footer.vue';

  export default {
    name: 'App',
    props: { },
    data() {
      return {
        selectedPeriod: Vue.prototype.$globalSharedData.selectedPeriod
      }
    },
    methods: {
      selectedPeriodChange(value) {
        const newValue = parseInt(value);
        this.selectedPeriod = newValue;
        Vue.prototype.$globalSharedData.selectedPeriod = newValue;
      } 
    },
    components: {
      Header,
      Editor,
      Footer,
    }
  }
</script>

<style>
  html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    font-family: sans-serif;
  }

  #app {
    display: flex;
    flex-flow: column;
    height: 100%;
  }

  #app .header {
    flex: 0 1 auto;
  }

  #app .editor {
    flex: 1 1 auto;
  }

  #app .footer {
    flex: 0 1 20px;
  }

  select, input {
    width: 170px;
    border-radius: 30px;
    background-color: white;
    padding: 2px 6px;
    border: 1px solid #999;
    font-size: 110%;
  }

  .control-input {
    padding: 6px 18px;
  }

  /* add animation effects */
  @-webkit-keyframes animatetop {
    from {top:-300px; opacity:0}
    to {top:0; opacity:1}
  }

  @keyframes animatetop {
    from {top:-300px; opacity:0}
    to {top:0; opacity:1}
  }


  /*  ---------------------- */
  /*
    TODO: This boxplot css part should not be here
    it needs to be placed in the correct component but for now lets us leave it here
  */
  .boxplot {
    font: 10px sans-serif;
  }

  .boxplot line, .boxplot rect, .boxplot circle {
    fill: steelblue;
    stroke: #000;
    stroke-width: 1px;
  }

  .boxplot .center {
    stroke-dasharray: 3,3;
  }

  .boxplot .outlier {
    fill: none;
    stroke: #000;
  }

  .axis {
    font: 12px sans-serif;
  }
  
  .axis path,
  .axis line {
    fill: none;
    stroke: #000;
    shape-rendering: crispEdges;
  }
  
  .x.axis path { 
    fill: none;
    stroke: #000;
    shape-rendering: crispEdges;
  }

  .tooltip {
    z-index: 99999;
    position: relative;
    display: inline-block;
  /* border-bottom: 1px dotted black; */
  }

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 99999;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
  z-index: 99999;
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  z-index: 99999;
  visibility: visible;
  opacity: 1;
}
</style>
